import React from 'react';
import { 
  Shield, ArrowRight, ShieldAlert, PackageX, HeartCrack, ChevronRight, 
  CheckCircle2, FileText, Database, Layers, Search, Mail, Send,
  Cpu, Sparkles, BookOpen, AlertTriangle, Eye, HelpCircle, ChevronDown, HelpCircle as HelpIcon
} from 'lucide-react';

export const IconMap = {
  shield: <Shield size={26} color="#d4ac0d" />,
  arrowRight: <ArrowRight size={20} />,
  shieldAlert: <ShieldAlert size={26} color="#f59e0b" />,
  packageX: <PackageX size={26} color="#ef4444" />,
  heartCrack: <HeartCrack size={26} color="#22c55e" />,
  chevronRight: <ChevronRight size={16} />,
  checkCircle: <CheckCircle2 size={20} color="#22c55e" />,
  fileText: <FileText size={26} color="#2e86c1" />,
  database: <Database size={26} color="#94a3b8" />,
  layers: <Layers size={26} color="#a855f7" />,
  search: <Search size={26} color="#14b8a6" />,
  mail: <Mail size={20} color="#64748b" />,
  send: <Send size={18} />,
  cpu: <Cpu size={24} color="#d4ac0d" />,
  sparkles: <Sparkles size={24} color="#2e86c1" />,
  bookOpen: <BookOpen size={24} color="#14b8a6" />,
  alertTriangle: <AlertTriangle size={24} color="#ef4444" />,
  eye: <Eye size={18} color="#0d1b2a" />,
  help: <HelpCircle size={20} color="#2e86c1" />,
  chevronDown: <ChevronDown size={18} />
};